import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-wrap-detail',
  templateUrl: './wrap-detail.component.html',
  styleUrls: ['./wrap-detail.component.scss']
})
export class WrapDetailComponent implements OnInit {
  @Input() firstLoading: any = {
    status: true,
    errorMessage: ''
  };

  constructor() { }

  ngOnInit(): void {
  }

}
